import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API, timeout: 15000 });

// Attach admin token if present
http.interceptors.request.use((config) => {
  const t = localStorage.getItem('alpha_admin_token');
  if (t) config.headers['X-Admin-Token'] = t;
  return config;
});

function errMsg(e) {
  return e?.response?.data?.detail || e?.message || 'Request failed';
}

export const api = {
  // Public
  async submitTraderId(traderId) {
    try {
      const { data } = await http.post('/verify', { trader_id: traderId });
      return { ok: true, status: data.status, message: data.message };
    } catch (e) {
      return { ok: false, message: errMsg(e) };
    }
  },
  async checkStatus(traderId) {
    try {
      const { data } = await http.get(`/status/${traderId}`);
      return { ok: true, status: data.status };
    } catch (e) {
      return { ok: false, message: errMsg(e) };
    }
  },
  async login(traderId) {
    try {
      const { data } = await http.post('/login', { trader_id: traderId });
      localStorage.setItem('alpha_current_trader', data.trader_id);
      return { ok: true, traderId: data.trader_id };
    } catch (e) {
      return { ok: false, message: errMsg(e) };
    }
  },
  logout() {
    localStorage.removeItem('alpha_current_trader');
  },
  getCurrent() {
    return localStorage.getItem('alpha_current_trader');
  },
  async generateSignal(pair, expiry) {
    try {
      const { data } = await http.post('/signal', { pair, expiry });
      return {
        ok: true,
        pair: data.pair,
        expiry: data.expiry,
        direction: data.direction,
        confidence: data.confidence,
        entryTime: data.entry_time,
        utc: data.utc,
      };
    } catch (e) {
      return { ok: false, message: errMsg(e) };
    }
  },

  // Admin
  async adminLogin(username, password) {
    try {
      const { data } = await http.post('/admin/login', { username, password });
      localStorage.setItem('alpha_admin_token', data.token);
      return { ok: true };
    } catch (e) {
      return { ok: false, message: errMsg(e) };
    }
  },
  async adminLogout() {
    try { await http.post('/admin/logout'); } catch (e) { /* ignore */ }
    localStorage.removeItem('alpha_admin_token');
  },
  isAdmin() {
    return !!localStorage.getItem('alpha_admin_token');
  },
  async listUsers(status = 'all') {
    try {
      const { data } = await http.get('/admin/users', { params: { status } });
      return { ok: true, users: data.users };
    } catch (e) {
      return { ok: false, message: errMsg(e), users: [] };
    }
  },
  async approveUser(traderId) {
    try { await http.post(`/admin/approve/${traderId}`); return { ok: true }; }
    catch (e) { return { ok: false, message: errMsg(e) }; }
  },
  async rejectUser(traderId) {
    try { await http.post(`/admin/reject/${traderId}`); return { ok: true }; }
    catch (e) { return { ok: false, message: errMsg(e) }; }
  },
  async deleteUser(traderId) {
    try { await http.delete(`/admin/user/${traderId}`); return { ok: true }; }
    catch (e) { return { ok: false, message: errMsg(e) }; }
  },
};
